import React from "react";

const SearchInput = ({
  value,
  onChange,
  placeholder = "Search...",
  fontSize,
}) => {
  return (
    <div className="flex flex-col justify-start items-center h-[36px] w-[342px] gap-2.5 p-2 rounded-md border border-[#a48572]/10">
      <div className="flex justify-start items-center w-full gap-2">
        {/* Search Icon */}
        <svg
          width={14}
          height={15}
          viewBox="0 0 14 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-3.5 h-3.5"
          preserveAspectRatio="xMidYMid meet"
        >
          <circle
            cx="6.86344"
            cy="7.36442"
            r="5.24333"
            stroke="#142b70"
            strokeOpacity="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5103 11.2852L12.5659 13.3355"
            stroke="#142b70"
            strokeOpacity="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        {/* Input Field */}
        <input
          type="text"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full text-${fontSize} text-[#142b70] placeholder-[#142b70]/50 focus:outline-none bg-transparent`}
        />
      </div>
    </div>
  );
};

export default SearchInput;
